export default __webpack_public_path__ + "static/media/misc-drawerB-1920w.eeab2cb9.png";